exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "virtual-scroll {\r\n  display: block;\r\n  height: 80vh;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/users/users.component.css
// module id = ../../../../../src/app/reports/myReports/zoomView/users/users.component.css
// module chunks = main